import { SHOP_TYPES } from "../types";

const initialState = {
  shops: [],
  count: 0,
  activeCount: 0,
  inactiveCount: 0,
  currentPage: 1,
  loading: false,
  shop: null,
  storeProducts: [],
  products: [],
  product: null,
  categories: [],
  category: null,
};

const shopReducers = (state = initialState, action) => {
  switch (action.type) {
    case SHOP_TYPES.SET_LOADING:
      return { ...state, loading: action.payload };

    case SHOP_TYPES.FETCH_SHOPS_SUCCESS:
      return {
        ...state,
        shops: action.payload.data,
        count: action.payload.count,
        activeCount: action.payload.active_count,
        inactiveCount: action.payload.inactive_count,
        currentPage: action.payload.page,
      };

    case SHOP_TYPES.FETCH_SHOP_SUCCESS:
      return { ...state, shop: action.payload };

    case SHOP_TYPES.FETCH_STORE_PRODUCTS:
      return { ...state, storeProducts: action.payload };

    case SHOP_TYPES.FETCH_PRODCUTS_SUCCESS:
      return { ...state, products: action.payload };

    case SHOP_TYPES.FETCH_PRODCUT_SUCCESS:
      return { ...state, product: action.payload };

    case SHOP_TYPES.FETCH_CATEGORYS_SUCCESS:
      return { ...state, categories: action.payload };

    case SHOP_TYPES.FETCH_CATEGORY_SUCCESS:
      return { ...state, category: action.payload };

    default:
      return state;
  }
};

export default shopReducers;
